import React from 'react';
import styled from 'styled-components';
import Icon from '../../Icon';

const TableHeaderContainer = styled.div`
  display: flex;
  padding: 7px;
  border: 1px solid rgba(31, 43, 55, 0.1);
  border-bottom: 2px solid ${(props) => props.theme.colors['terra-cotta']};
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex: 1;
  height: 100%;
  outline: none !important;
  min-height: 50px;
  background-color: rgba(43, 61, 84, 0.1);

  &:hover {
    cursor: pointer;
    opacity: 0.6;
  }

  .iconsContainer {
    display: flex;
    flex-direction: row;
    align-items: center;

    > * {
      font-size: 6px;
    }
  }

  ${(props) => props.styles}
`;

const HeaderExtend = ({ styles, onClick, isRetracted }) => (
  <TableHeaderContainer
    onClick={onClick ? () => onClick() : undefined}
    styles={styles}
  >
    {isRetracted ? (
      <div className="iconsContainer">
        <Icon icon="chevronLeft" />
        <Icon icon="chevronRight" />
      </div>
    ) : (
      <div className="iconsContainer">
        <Icon icon="chevronRight" />
        <Icon icon="chevronLeft" />
      </div>
    )}
  </TableHeaderContainer>
);

export default HeaderExtend;
